<template>
    <custom-table
        :title="$t('pages.user.role.title')"
        :subTitle="$t('pages.user.role.subTitle')"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        @action="handleClickAction"
        @changeTable="handleTableChange"
    >
        <template v-slot:code="{ row: record }">
            {{ record.code }}
        </template>
        <template v-slot:name="{ row: record }">
            {{ record.name }}
        </template>

        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('pages.user.role.showUsers')" placement="top">
                    <router-link :to="'/user/?roles[]=' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/general/gen004.svg"/>
                     </span>
                    </router-link>
                </el-tooltip>
            </div>
        </template>
    </custom-table>

</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "user",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.user.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.user.role.cols.code"),
                    scopedSlots: {customRender: "code"}
                },
                {
                    name: this.$t("pages.user.role.cols.name"),
                    scopedSlots: {customRender: "name"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                }
            ],
            rules: {},
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    created() {

    },
    computed: {
        table() {
            return this.$store.state.user.role.table;
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.userRoles"), []);

        this.$store.dispatch('user/role/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
        });
    },
    methods: {
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;
                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('user/role/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("user/role/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        }
    }
}
</script>

<style scoped>

</style>